/** avatar-color — derive initials and a stable tinted colour from a display name. */

/** Returns up to 2-letter initials from a name string. */
export function initials(name: string | undefined | null): string {
  if (!name) return '?';
  // strip leading non-letters (numbers, symbols)
  const clean = name.replace(/^[^a-zA-Z]+/, '');
  if (!clean) return '?';
  const words = clean.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  const first = words[0][0] ?? '';
  const last  = words.length > 1 ? (words[words.length - 1][0] ?? '') : '';
  return (first + last).toUpperCase() || '?';
}

/** Stable bg/fg token pair derived from the name — always one of 8 avatar palette slots. */
export function avatarColor(name: string | undefined | null): { bg: string; fg: string } {
  const str = name ?? '';
  let hash = 0;
  // Multiplicative (not additive) so anagrams like "Lee"/"Eel" land on different slots.
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  // 1-indexed slots 1..8 (Math.abs guards the sign bit from the |0 wrap)
  const slot = (Math.abs(hash) % 8) + 1;
  return {
    bg: `var(--avatar-${slot}-bg)`,
    fg: `var(--avatar-${slot}-fg)`,
  };
}
